<!-- src/components/ContentPage.vue -->
<template>
    <div class="info-page-container">
        <div class="info-content-wrapper">
            <!-- PC: ← Back -->
            <div class="breadcrumb breadcrumb-pc" @click="goBack">
                <span class="back-arrow">←</span>
                <span class="breadcrumb-text">Back</span>
            </div>
            <!-- H5: Home icon -->
            <div class="breadcrumb breadcrumb-h5" @click="goHome">
                <span class="home-icon-fallback">
                    <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                </span>
                <span class="breadcrumb-text">Home</span>
            </div>

            <div class="info-content-box">
                <component :is="currentComponent" />
            </div>
        </div>
    </div>
</template>

<script>
import PlatformDisclaimer from './content/PlatformDisclaimer.vue'
import GrowthProgramOverview from './content/GrowthProgramOverview.vue'
import SmartRewardsRules from './content/SmartRewardsRules.vue'
import SmartRewardsTerms from './content/SmartRewardsTerms.vue'
import IntellectualPropertyPolicy from './content/IntellectualPropertyPolicy.vue'
import PrivacyPolicyContent from './content/PrivacyPolicyContent.vue'
import TermsOfServiceContent from './content/TermsOfServiceContent.vue'
import XigcheckAuthenticationProcessPolicy from './xigcheck/AuthenticationProcessPolicy.vue'
import XigcheckBrandCategories from './xigcheck/BrandCategories.vue'
import XigcheckComplianceProtection from './xigcheck/ComplianceProtection.vue'
import XigcheckFraudPrevention from './xigcheck/FraudPrevention.vue'
import XigcheckFraudPreventionPolicy from './xigcheck/FraudPreventionPolicy.vue'
import XigcheckHighValueGoodsPolicy from './xigcheck/HighValueGoodsPolicy.vue'
import XigcheckHowItWorks from './xigcheck/HowItWorks.vue'
import XigcheckIndependentReview from './xigcheck/IndependentReview.vue'
import XigcheckNoEscrow from './xigcheck/NoEscrow.vue'
import XigcheckNoFinancialServices from './xigcheck/NoFinancialServices.vue'
import XigcheckPrivacyPolicy from './xigcheck/PrivacyPolicy.vue'
import XigcheckRefundPolicy from './xigcheck/RefundPolicy.vue'
import XigcheckSupportedCategories from './xigcheck/SupportedCategories.vue'
import XigcheckTermsOfService from './xigcheck/TermsOfService.vue'
import XigcheckTrustLayer from './xigcheck/TrustLayer.vue'

export default {
    name: 'ContentPage',
    components: {
        PlatformDisclaimer,
        GrowthProgramOverview,
        SmartRewardsRules,
        SmartRewardsTerms,
        IntellectualPropertyPolicy,
        PrivacyPolicyContent,
        TermsOfServiceContent,
        XigcheckAuthenticationProcessPolicy,
        XigcheckBrandCategories,
        XigcheckComplianceProtection,
        XigcheckFraudPrevention,
        XigcheckFraudPreventionPolicy,
        XigcheckHighValueGoodsPolicy,
        XigcheckHowItWorks,
        XigcheckIndependentReview,
        XigcheckNoEscrow,
        XigcheckNoFinancialServices,
        XigcheckPrivacyPolicy,
        XigcheckRefundPolicy,
        XigcheckSupportedCategories,
        XigcheckTermsOfService,
        XigcheckTrustLayer
    },
    computed: {
        currentComponent() {
            const type = this.resolveType()
            switch (type) {
                case 'privacy-policy':
                    return 'PrivacyPolicyContent'
                case 'terms-of-service':
                    return 'TermsOfServiceContent'
                case 'platform-disclaimer':
                    return 'PlatformDisclaimer'
                case 'growth-program':
                    return 'GrowthProgramOverview'
                case 'smartrewards-rules':
                    return 'SmartRewardsRules'
                case 'smartrewards-terms':
                    return 'SmartRewardsTerms'
                case 'intellectual-property':
                    return 'IntellectualPropertyPolicy'
                case 'xigcheck-trust-layer':
                    return 'XigcheckTrustLayer'
                case 'xigcheck-how-it-works':
                    return 'XigcheckHowItWorks'
                case 'xigcheck-supported-categories':
                    return 'XigcheckSupportedCategories'
                case 'xigcheck-brand-categories':
                    return 'XigcheckBrandCategories'
                case 'xigcheck-compliance-protection':
                    return 'XigcheckComplianceProtection'
                case 'xigcheck-fraud-prevention':
                    return 'XigcheckFraudPrevention'
                case 'xigcheck-fraud-prevention-policy':
                    return 'XigcheckFraudPreventionPolicy'
                case 'xigcheck-high-value-goods-policy':
                    return 'XigcheckHighValueGoodsPolicy'
                case 'xigcheck-independent-review':
                    return 'XigcheckIndependentReview'
                case 'xigcheck-no-escrow':
                    return 'XigcheckNoEscrow'
                case 'xigcheck-no-financial-services':
                    return 'XigcheckNoFinancialServices'
                case 'xigcheck-terms-of-service':
                    return 'XigcheckTermsOfService'
                case 'xigcheck-privacy-policy':
                    return 'XigcheckPrivacyPolicy'
                case 'xigcheck-refund-policy':
                    return 'XigcheckRefundPolicy'
                case 'xigcheck-authentication-process-policy':
                    return 'XigcheckAuthenticationProcessPolicy'
                default:
                    return 'TermsOfServiceContent'
            }
        }
    },
    methods: {
        resolveType() {
            if (this.$route.params.type) {
                if (this.$route.path.indexOf('/xigcheck/') === 0) {
                    return `xigcheck-${this.$route.params.type}`
                }
                return this.$route.params.type
            }

            switch (this.$route.path) {
                case '/privacy-policy':
                    return 'privacy-policy'
                case '/terms-of-service':
                    return 'terms-of-service'
                default:
                    return 'platform-disclaimer'
            }
        },
        goBack() {
            this.$router.back()
        },
        goHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>
.info-page-container {
    min-height: calc(100vh - 300px);
    background-color: #fff;
    padding: 40px 10%;
}

.info-content-wrapper {
    width: 100%;
    /* max-width: 900px; */
}

.breadcrumb {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 32px;
}

/* PC shows Back, H5 hidden */
.breadcrumb-pc {
    display: flex;
}
.breadcrumb-h5 {
    display: none;
}

.back-arrow {
    font-size: 20px;
    color: #333;
    margin-right: 10px;
    font-weight: 500;
}

.home-icon-fallback {
    display: flex;
    align-items: center;
    margin-right: 8px;
    color: #555;
}

.breadcrumb-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: rgba(108, 108, 120, 1);
}

.breadcrumb:hover .breadcrumb-text,
.breadcrumb:hover .back-arrow {
    color: #ff5e62;
}

.info-content-box {
    width: 100%;
}

@media (max-width: 900px) {
    .info-page-container {
        padding: 20px 16px;
        background-color: #fcfcfc;
    }
    .info-content-wrapper {
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
        padding: 20px 16px;
    }
    /* H5 shows Home, PC hidden */
    .breadcrumb-pc {
        display: none;
    }
    .breadcrumb-h5 {
        display: flex;
    }
    .breadcrumb {
        margin-bottom: 20px;
        cursor: default;
    }
    .breadcrumb-text {
        font-size: 14px;
        color: #555;
    }
}
</style>
